/**
 * Card · CardHeader · CardBody — mobil listelerin taşıyıcısı.
 *
 * Mobilde tablo yerine kart kullanılır [K-020]: dar ekranda yatay kaydırma
 * yerine dikey akış. Aynı veri masaüstünde `Table` ile gösterilir — iki
 * sunum, tek veri modeli.
 */
import type { ReactNode } from 'react';

import { cx } from './cx.ts';

export interface CardProps {
  readonly children: ReactNode;
  /** Tıklanabilir kart — tüm alan dokunma hedefi olur. */
  readonly onClick?: () => void;
  readonly interactive?: boolean;
}

export function Card({ children, onClick, interactive = false }: CardProps): React.JSX.Element {
  const clickable = interactive || onClick !== undefined;
  const Tag = clickable ? 'button' : 'div';
  return (
    <Tag
      {...(clickable ? { type: 'button' as const, onClick } : {})}
      className={cx(
        'w-full rounded-[var(--radius-card)] border border-border bg-surface text-left',
        clickable && 'transition-colors hover:bg-surface-sunken active:bg-surface-sunken',
      )}
    >
      {children}
    </Tag>
  );
}

export function CardHeader({ children }: { readonly children: ReactNode }): React.JSX.Element {
  return <div className="flex items-start justify-between gap-3 px-4 pt-4 pb-2">{children}</div>;
}

export function CardBody({ children }: { readonly children: ReactNode }): React.JSX.Element {
  return <div className="px-4 pb-4">{children}</div>;
}
